import Base from './Base';

class Games extends Base {
    findById(gameId, opts = null) {
        return this.getJSONWithSession(
            this.urlGenerator('game.json', {
                game: gameId,
            }),
            {
                resource: true,
            },
            opts,
        );
    }

    answer(gameId, answer, opts = null) {
        return this.postJSONWithSession(
            this.urlGenerator('game.answer', {
                game: gameId,
            }),
            { answer },
            opts,
        );
    }

    answerQuestion(gameId, questionId, answer, opts = null) {
        return this.postJSONWithSession(
            this.urlGenerator('game.answer.question', {
                game: gameId,
                question: questionId,
            }),
            { answer },
            opts,
        );
    }

    endGame(participationId, opts = null) {
        return this.postJSONWithSession(
            this.urlGenerator('participation.end', {
                participation: participationId,
            }),
            null,
            opts,
        );
    }
}

export default Games;
